export class ExpressCloud {
  id = null
  parse_setting_id = null
  codeText = null
  current_version_id = false

  constructor(origin) {
    if (!origin) return
    this.id = origin.id
    this.parse_setting_id = origin.parse_setting_id
    this.codeText = origin.code_text
    this.current_version_id = origin.current_version_id
  }

  getServerObject() {
    return {
      site_id: this.site_id,
      code_text: this.codeText,
    }
  }
}
